import { render, staticRenderFns } from "./VehicleUpcomingExpiries.vue?vue&type=template&id=f04e513e&"
import script from "./VehicleUpcomingExpiries.vue?vue&type=script&lang=js&"
export * from "./VehicleUpcomingExpiries.vue?vue&type=script&lang=js&"
import style0 from "./VehicleUpcomingExpiries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports